import { render, staticRenderFns } from "./PrintersTable.vue?vue&type=template&id=6ac0826c&scoped=true&"
import script from "./PrintersTable.vue?vue&type=script&lang=js&"
export * from "./PrintersTable.vue?vue&type=script&lang=js&"
import style0 from "./PrintersTable.vue?vue&type=style&index=0&id=6ac0826c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac0826c",
  null
  
)

export default component.exports